module.exports = __webpack_public_path__ + "static/media/8_Days of the Week 2.43c0e91d.jpg";